/* eslint-disable react/prop-types */
import React from 'react';
import { X } from 'lucide-react';
import styles from './CloseButton.module.css';

function CloseButton({
  onClick,
  width = '35px',
  height = '35px',
}) {
  return (
    <button
      type="button"
      className={styles.buttonDelete}
      onClick={onClick}
      style={{
        background: 'none',
        cursor: 'pointer',
        border: 'none',
        height,
        width,
        padding: 'var(--space-xs)',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 'var(--radius-xl)',
      }}
    >
      <X
        className={styles.trash}
        style={{ color: 'var(--visible)' }}
        size={20}
      />
    </button>
  );
}
export default CloseButton;
